import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { sendViewRoadmapScreenAnalyticsEvent } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/analytics';
import { reportTimeToInteractive } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive';
import type { ReportTimeToInteractivePayload } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive/types';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import type { DispatchProps } from './types';

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps> = (dispatch) => ({
	onRoadmapView: (analyticsEvent: UIAnalyticsEvent) => {
		dispatch(sendViewRoadmapScreenAnalyticsEvent(analyticsEvent));
	},
	reportTimeToInteractive: (payload: ReportTimeToInteractivePayload) =>
		dispatch(reportTimeToInteractive(payload)),
});

export default mapDispatchToProps;
